import React from 'react';
import { Autocomplete, Chip, TextField, Checkbox } from '@mui/material';

export default function AutocompleteWithSelectAll({ value = [], onChange, options = [], placeholder = "", enableSelectAll = false, ...rest }) {
  const allSelected = value.length === options.length;
  const handleChange = (event, selectedOptions) => {
    if (enableSelectAll && selectedOptions.some(opt => opt.value === "__ALL__")) {
      onChange(allSelected ? [] : options.map(opt => opt.value));
      return;
    }
    onChange(selectedOptions.map(opt => opt.value));
  };
  const renderOptions = enableSelectAll ? [{ label: "Select All", value: "__ALL__" }, ...options] : options;
  const selectedOptions = renderOptions.filter(opt => value.includes(opt.value));

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      value={selectedOptions}
      onChange={handleChange}
      options={renderOptions}
      getOptionLabel={(opt) => opt.label}
      renderTags={(tagValue, getTagProps) => {
        const max = 3;
        const totalSelected = selectedOptions.length;
        const remainder = totalSelected - max;
        const chips = tagValue.slice(0, max).map((option, index) => (
          <Chip {...getTagProps({ index })} key={option.value} label={option.label} />));
        if (remainder > 0) chips.push(<span key="more"> +{remainder} </span>);
        return chips;
      }}
      renderOption={(props, option, { selected }) => (
        <li {...props} style={{ display: "flex", alignItems: "center" }}>
          <Checkbox checked={selected} style={{ marginRight: 8 }} /> {option.label}
        </li>
      )}
      renderInput={(params) => <TextField {...params} placeholder={placeholder} />}
      {...rest}
    />
  );
}
